'use client';

import classNames from 'classnames';
import React, { FC, useEffect } from 'react';

interface AddToCartErrorMessageProps {
  error: string;
  testId?: string;
  className?: string;
  onDismiss?: () => void;
}

const AUTO_DISMISS_TIME = 5000;

const AddToCartErrorMessage: FC<AddToCartErrorMessageProps> = ({
  error,
  testId = 'add-to-cart-error-message',
  className,
  onDismiss,
}) => {
  useEffect(() => {
    if (!onDismiss) return;

    const timer = setTimeout(() => {
      onDismiss();
    }, AUTO_DISMISS_TIME);

    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <p
      className={classNames(`text-sm text-center text-warning mt-2`, className)}
      data-testid={testId}
      role="alert"
      aria-live="assertive"
    >
      {error}
    </p>
  );
};

export default AddToCartErrorMessage;
